export default __webpack_public_path__ + "static/media/calendarIconHCSelected.8647dd96.svg";